import React from "react";
import PropTypes from "prop-types";
const SimpleCartIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 22}
    height={height || size || 21}
    viewBox="0 0 22 21"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-1-2h24v24H-1z" />
      <g
        stroke={color || "var(--color-easil-gray-x-dark)"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(1 1)"
      >
        <circle
          cx="7.238"
          cy="18.095"
          r="1"
          fill={color || "var(--color-easil-gray-x-dark)"}
        />
        <circle
          cx="17.19"
          cy="18.095"
          r="1"
          fill={color || "var(--color-easil-gray-x-dark)"}
        />
        <path d="M0 0h3.619l2.425 12.115a1.81 1.81 0 0 0 1.81 1.456h8.794a1.81 1.81 0 0 0 1.81-1.456l1.447-7.591H4.524" />
      </g>
    </g>
  </svg>
);
SimpleCartIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default SimpleCartIcon;
